/**
 *
 * @module dustCategory
 * @see https://github.bamtech.co/sdk-doc/spec-sdk/blob/master/specs/feature_overviews/dust.md
 * @see https://github.bamtech.co/sdk-doc/spec-sdk/blob/master/specs/feature_overviews/dust.md#categories
 *
 */

/**
 *
 * @access private
 * @typedef SDK.Services.Internal.Dust.DustCategory
 * @type {Object}
 * @since 3.4.0
 * @desc Internal DUST API category reference
 *
 */

/**
 *
 * @type {SDK.Services.Internal.Dust.DustCategory}
 *
 */
export default {

    api: {
        event: ':event:sdk',
        error: ':error:sdk'
    },
    service: {
        event: ':event:service',
        error: ':error:service'
    },
    glimpse: 'urn:bamtech:dust:bamsdk:event:glimpse',
    personalization: 'urn:bamtech:dust:bamsdk:event:app'

};



// WEBPACK FOOTER //
// ./src/services/internal/dust/dustCategory.js